import { BaseEntity } from "@app/models/rest/base-entity";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("autoBookHistories")
export class AutoBookHistory extends BaseEntity {
  externalJobRef: string;
  visitId: number;
  bookedDate: Date;
  appointmentStart: Date;
  appointmentEnd: Date;
  success: boolean;
  message: string;
  autoBookProfileId: number;
  priorityId: number;
  priorityDescription: string;
}
